import { Column, Row, Text } from '~/commonComponents';
import { CheckSingleIcon } from '~/images/icons';
import BulbIcon from '~/images/icons/BulbIcon';
import { Colors } from '~/themes/colors';

const tips = [
  {
    title: 'Pre-Screened, Ready-to-Work Professionals',
    description: 'Only candidates who watch your requirements can apply',
  },
  {
    title: 'See Them in Action First',
    description: 'Schedule onsite interviews to evaluate skills before hiring',
  },
  {
    title: '30-Day Active Posting with Auto-Renewal',
    description: 'Your job stays live and visible to thousands of qualified candidates',
  },
];

export const PermanentJobsTips = () => {
  return (
    <Column
      backgroundColor={Colors.secondary_50}
      borderRadius={8}
      paddingBlock={30}
      paddingInline={35}
    >
      <Text bold color={Colors.primary_500} fontSize={18}>
        Start Receiving Qualified Candidates Today
      </Text>
      <Column gap={14} marginTop={14} marginBottom={30}>
        {tips.map(({ description, title }, i) => (
          <Row gap={2} key={i}>
            <CheckSingleIcon color={Colors.secondary_500} />
            <Column>
              <Text bold>{title}</Text>
              <Text color={Colors.neutral_500}>{description}</Text>
            </Column>
          </Row>
        ))}
      </Column>
      <Row
        alignItems="center"
        backgroundColor={Colors.white}
        borderRadius={8}
        gap={5}
        paddingBlock={8}
        paddingInline={12}
      >
        <BulbIcon color={Colors.secondary_500} />
        <Text bold color={Colors.primary_500}>
          Tips:{' '}
        </Text>
        <Text>
          Offices that post jobs and onsite interviews fill positions <Text bold>3x faster</Text>{' '}
          than traditional hiring methods.
        </Text>
      </Row>
    </Column>
  );
};
